import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Skeleton } from "../ui/skeleton";
import {
    sanitizePhoneNumber,
    formatPhoneNumber,
} from "@/utils/phone/phoneUtils";
import { useFacility } from "@/hooks/useFacility.tsx";

export const NoUnitsAvailable = () => {
    const options = useDisplayOptionContext();
    const mainFacilityId = options.facilityIds[0];
    const { facility, isLoading, error } = useFacility(mainFacilityId);

    const facilityPhone = facility?.phone;

    const sanitizedPhoneNumber = sanitizePhoneNumber(facilityPhone);
    const formattedPhoneNumber = formatPhoneNumber(facilityPhone);

    return (
        <Card className="units-unavailable-card">
            <CardHeader>
                <CardTitle>
                    <h2>
                        We're sorry, there are no units available at this time
                    </h2>
                </CardTitle>
            </CardHeader>
            <CardContent>
                {error ? (
                    "Oh no, there was an error! {error.status}"
                ) : isLoading ? (
                    <Skeleton className="tw:w-[200px] tw:h-[20px] tw:rounded-full" />
                ) : facility ? (
                    <p>
                        For more information on unit availability, please call{" "}
                        <a href={`tel:${sanitizedPhoneNumber}`}>
                            {formattedPhoneNumber}
                        </a>
                    </p>
                ) : null}
            </CardContent>
        </Card>
    );
};
